import React from 'react';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import SearchIcon from '@mui/icons-material/Search';
import LoadingIndicator from '../LoadingIndicator';
import TokenService from '../../services/TokenService'
import { useSnackbar } from 'notistack';
import cloneDeep from 'lodash/cloneDeep';
import Avatar from '@mui/material/Avatar';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SortableFilterTable from '../SortableFilterTable.jsx';
import dayjs from 'dayjs';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import RecyclerItem from '../Admin/RecyclerItem';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Scheduler from '../Pickups/Scheduler';

function ReassignPickupModal(props) {
    var utc = require('dayjs/plugin/utc')
    dayjs.extend(utc);
    var duration = require('dayjs/plugin/duration')
    dayjs.extend(duration);
    var relativeTime = require('dayjs/plugin/relativeTime')
    dayjs.extend(relativeTime)

    const [showScheduler, setShowScheduler] = React.useState(false);
    const [searchValue, setSearchValue] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [recyclers, setRecyclers] = React.useState([]);
    const [selectedRecyclerId, setSelectedRecyclerId] = React.useState(0);
    const {enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [selectedTime, setSelectedTime] = React.useState(null);

    function showLoadingIndicator() {
        return <LoadingIndicator Message={'Loading'} />
    }

    function adminRecyclerSearch() {
        // if (searchValue.trim().length != 0) {
        let postData = {
            searchValue: searchValue.trim(),
            status: 'Active',
            hasOpenOrders: false,
            hasPaidOrders: false
        }

        setIsLoading(true);
        TokenService.post(postData, 'Admin_ReturnerSearch')

            .then((response) => {
                setIsLoading(false);
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    setRecyclers(jsonData);
                }
                else {
                    enqueueSnackbar(response.Message, {
                        variant: 'error',
                    });
                }

            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
                setIsLoading(false);
            });
        //}
        //else {
        //    enqueueSnackbar("Can't be blank", {
        //        variant: 'error',
        //    });
        //}
    }

    const handleClose = (accepted) => {
        let selectedRecycler = null
        for (let i = 0; i < recyclers.length; i++) {
            if (recyclers[i].ID == selectedRecyclerId) {
                selectedRecycler = recyclers[i];
                break;
            }
        }
        props.onClose(accepted, selectedRecycler, selectedDate, selectedTime);
    };

    function buildRecyclers() {
        if (searchValue.trim() == '' && recyclers.length == 0) {
            return;
        }
        if (recyclers.length === 0) {
            return (<div>No results</div>)
        }

        let tableData = [];


        return (<div>
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue=""
                value={selectedRecyclerId}
                onChange={(e) => { setSelectedRecyclerId(parseInt(e.target.value)); }}
                name="radio-buttons-group"
            >
            {recyclers.map((recycler, index) => {
                return (<div style={{ display: 'flex', marginBottom:'5px', padding:'5px', borderTop:'1px solid #efefef' }}>
                    <div>
                        <div style={{ display: 'flex' }}>
                            <Avatar
                                alt="Photo"
                                src={recycler.ReturnerPhoto}
                                sx={{ width: 40, height: 40, alignSelf: 'center', marginRight:'5px' }}
                            />
                            <div>
                                <div>{recycler.FirstName} {recycler.LastName}</div>
                                <div style={{fontStyle:'italic', fontSize: '9pt'} }>{recycler.EmailAddress}</div>
                            </div>

                        </div>
                       
                    </div>
                    <div style={{ marginLeft: 'auto' }}> <FormControlLabel value={recycler.ID} control={<Radio />} label="Select" /></div>
                </div>)
            })
                }
                </RadioGroup>
            
        </div>)
    }

    function onScheduled(pickupRequest, date, time) {
        setSelectedDate(date);
        setSelectedTime(time);
    }

    let canProceed = false;
    if (selectedRecyclerId > 0) {
        if (props.Order.Status_Reason == 'Scheduled') {
            canProceed = true;
        }
        else if (selectedDate != null && selectedTime != null) {
            canProceed = true;
        }
    }



    return (<Dialog
       
            onClose={() => handleClose(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            open={true}
        >
            <DialogTitle id="alert-dialog-title">
                Select a Recycler
            </DialogTitle>
            <DialogContent>
            <div style={{minWidth:'320px' }}>
                {isLoading ?
                    showLoadingIndicator()
                    :
                    
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '5px', marginTop: '5px' }}>
                            <TextField value={searchValue} label='Search' onChange={(e) => setSearchValue(e.target.value)} />
                            <Fab onClick={adminRecyclerSearch} style={{ marginLeft: '15px', backgroundColor: 'var(--sipzee-green)' }}><SearchIcon /></Fab>
                        </div>
                        <div>

                            {buildRecyclers()}

                        </div>
                    </div>

                }
            </div>
            {props.Order.Status_Reason != 'Unscheduled' || selectedRecyclerId == 0 ? null :
                <Scheduler PickupRequest={props.Order} onScheduled={onScheduled} viewType='Admin' />
            }
            </DialogContent>
            <DialogActions>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>


                <Button variant='outlined' onClick={() => handleClose(false)}>Cancel</Button>
                <Button variant='outlined' onClick={() => handleClose(true)} autoFocus disabled={!canProceed}>Proceed</Button>

            </div>
            </DialogActions>
        </Dialog>
    )
}
export default ReassignPickupModal;